import { isNotAuth } from '@/services/PermissionService';
import Names from './names';

export default {
	path: '/login',
	name: Names.Login,
	component: () => import('../views/LoginView'),
	meta: {
		title: 'Login',
		middleware: [isNotAuth],
	},
};
